module.exports = __webpack_public_path__ + "img/avatar-group-hover.461a1636.svg";